import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconHoum from '../build/icon-houm'

export const IconHoum: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconHoum} />
}

export default IconHoum
